<template>
  <div class="posts-wrapper">
    <div class="packages">

      <div class="filters">
        <div class="title">Búsqueda</div>
        <div class="wrap-filter">
          <div class="item">
            <vs-input label="Cliente" v-model="customerName" />
          </div>
          <div class="item">
            <vs-input label="Tracking" v-model="tracking" />
          </div>
          <div class="item">
            <label for="">Fechas</label>
            <v-date-picker mode="range" v-model="dateFilter" locale="es"
              :popover="{ placement: 'top', visibility: 'click' }"></v-date-picker>
          </div>
          <div class="item">
            <vs-input label="Ubicación" v-model="location" />
          </div>
          <div class="item btnFilter">
            <vs-button id="btnFilter" class="vs-con-loading__container" color="primary" type="border" icon="search"
              @click="getInventories()">Filtrar</vs-button>
            <vs-button color="success" to="/inventory/track" type="border" icon="refresh" class="ml-10">Track
              Packs</vs-button>

          </div>
        </div>
      </div>

      <!-- Modal con el spinner -->
      <transition name="fade">
        <div v-if="isDispatching" class="modal-overlay">
          <div class="modal-content">
            <div class="spinner"></div>
            <p>Despachando todos los paquetes...</p>
          </div>
        </div>
      </transition>

      <div class="box-white-wrapper">
        <div class="d-flex mb-4 flex-end dispatchAll">
          <span v-if="!isDispatching">Despachar todos</span>
          <!-- <span v-if="isDispatching" class="dispatchAll-loading-message">Cargando... Despachando todos</span> -->
          <vs-switch v-model="dispachAll" color="success" @change="changeDispathAll()" :disabled="isDispatching" />
        </div>

        <!-- <p v-if="isDispatching" class="dispatchAll-loading-text">Cargando... Por favor espere mientras se despachan todos los paquetes.</p> -->
        <vs-table :data="inventories" pagination search max-items="50" :key="keyPackages">
          <template slot="header" v-if="userInfoData.role == Roles.Admin">
            <vs-button color="primary" to="/inventory/add" type="border" icon="library_add"
              style="margin-right: 15px">Agregar</vs-button>
            <!-- <vs-button color="success" to="/inventory/track" type="border" icon="find_replace">Buscar</vs-button> -->
          </template>
          <template slot="thead">
            <vs-th sort-key="prealerted" v-if="userInfoData.role === Roles.Admin"></vs-th>
            <vs-th sort-key="customerName">Barcode</vs-th>
            <vs-th sort-key="customerName">Nombre</vs-th>
            <vs-th sort-key="tracking">Tracking </vs-th>
            <vs-th sort-key="inv02Code">Ubicación </vs-th>
            <!-- <vs-th sort-key="weight"> Peso </vs-th> -->
            <vs-th sort-key="product"> Producto </vs-th>
            <vs-th sort-key="image" v-if="userInfoData.role === Roles.Admin"> Factura </vs-th>
            <vs-th sort-key="prealerted" v-if="userInfoData.role === Roles.Admin"> ¿Listo Despachar? </vs-th>
            <vs-th sort-key="createdAt"> Fecha </vs-th>
            <vs-th sort-key="dispatched"> Estado </vs-th>
            <vs-th sort-key="id" class="width-30"></vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr :key="indextr" v-for="(tr, indextr) in data">

              <vs-td :data="data[indextr].customerName" class="nopl" v-if="userInfoData.role === Roles.Admin">
                <div class="circle success" v-if="data[indextr].prealerted == 1"></div>
                <div class="circle status-4" v-if="data[indextr].prealerted != 1"></div>
                <div class="circle danger" v-if="data[indextr].followup == 1"></div>
              </vs-td>
              <vs-td :data="data[indextr].id">{{ data[indextr].id }}</vs-td>
              <vs-td :data="data[indextr].customerName">
                {{

                  data[indextr].pkg01Id !== null ?
                    data[indextr].customer.firstName + " " + data[indextr].customer.lastName
                    :
                    "Sin Asignar"
                }}
              </vs-td>
              <vs-td :data="data[indextr].tracking">
                <router-link :to="`package/${data[indextr].pkg01Id}`" target="_blank"
                  v-if="data[indextr].pkg01Id != null">{{ data[indextr].tracking }}</router-link>
                <span v-if="data[indextr].pkg01Id == null">{{ data[indextr].tracking }}</span>
              </vs-td>
              <vs-td :data="data[indextr].inv02Code">{{ data[indextr].inv02Code }}</vs-td>
              <!-- <vs-td :data="data[indextr].weight">{{data[indextr].weight }}</vs-td> -->
              <vs-td :data="data[indextr].product">{{ data[indextr].product.name }}</vs-td>
              <vs-td :data="data[indextr].image" v-if="userInfoData.role === Roles.Admin">
                <a href="javascript:void(0)" v-if="data[indextr].image" @click="showSingle(data[indextr].image)">Ver</a>
                <span v-if="!data[indextr].image"
                  @click="openModalFile(data[indextr].pkg01Id, data[indextr].cu01Id)">Adjuntar</span>
              </vs-td>
              <vs-td :data="data[indextr].image" v-if="userInfoData.role === Roles.Admin">
                <vs-switch v-model="data[indextr].prealerted" color="success"
                  @change="changePrealerted(data[indextr].pkg01Id, data[indextr].prealerted)"
                  v-if="data[indextr].pkg01Id != null" :disabled="isDispatching" />
                <span v-if="data[indextr].pkg01Id == null"> N.A </span>
              </vs-td>
              <vs-td :data="data[indextr].createdAt">{{ data[indextr].createdAt | moment('DD/MM/YYYY') }}</vs-td>

              <vs-td :data="data[indextr].dispatched">
                <!-- <span :class="`status status-${data[indextr].statuscode}`" @click="changePackageStatus(data[indextr].id,'single')"> -->
                <!-- {{ data[indextr].dispatched == 1 ? 'Despachado' : 'Pendiente' }} -->
                {{ data[indextr].status.displayName }}
                <!-- </span> -->
              </vs-td>

              <vs-td :data="data[indextr].id" style="min-width: 120px;">
                <div class="table-actions" v-if="userInfoData.role != Roles.Distribuitor">
                  <router-link :to="`/inventory/detail/${data[indextr].id}`">
                    <feather type="eye" />
                  </router-link>
                  <a href="javascript:void(0)" @click="openModal(data[indextr].id)"
                    v-if="userInfoData.role === Roles.Admin">
                    <feather type="user-plus" />
                  </a>
                  <a href="javascript:void(0)" @click="onConfirmDeleteInv(data[indextr].id)"
                    v-if="userInfoData.role === Roles.Admin">
                    <feather type="trash" />
                  </a>
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
    <modalBasic :show="modalActive">
      <div class="modal-header" slot="modal-header">Asignar Cliente</div>
      <div class="modal-body" slot="modal-body">
        <form>
          <select-input :options="customers" v-model="customer"></select-input>
        </form>
      </div>
      <div class="modal-footer" slot="modal-footer">
        <vs-button color="danger" type="border" icon="block" @click="closeModal()">Cancelar</vs-button>
        <vs-button :disabled="customer != '' ? false : true" id="btnConfirm" color="success" type="border" icon="check"
          @click="handleAssign" class="vs-con-loading__container"> Actualizar</vs-button>
      </div>
    </modalBasic>

    <vue-easy-lightbox escDisabled :moveDisabled="false" :visible="visible" :imgs="imgs"
      @hide="handleHide"></vue-easy-lightbox>

    <modalBasic :show="modalAttachBill">
      <div class="modal-header" slot="modal-header">Adjuntar Factura</div>
      <div class="modal-body limit-body" slot="modal-body">
        <form class="form">
          <div class="form-input">
            <input type="file" @change="uploadFile" ref="file" accept=".pdf, image.*">
          </div>
        </form>
      </div>
      <div class="modal-footer" slot="modal-footer">
        <vs-button color="danger" type="border" icon="block" @click="closeModalFile()">Cerrar</vs-button>
        <vs-button :disabled="stateFileUpload || fileBill == ''" id="btnConfirm" color="success" type="border"
          icon="check" @click="sendFileToServer" class="vs-con-loading__container"> Enviar</vs-button>
      </div>
    </modalBasic>

  </div>
</template>
<script>
import { mapState, } from 'vuex'
import { helper } from '@/helpers/utils'
import { Role } from '@/helpers/Role.js'
import PackageModel from "@/models/PackageModel"
import { required } from 'vuelidate/lib/validators'
import InventoryService from "@/services/InventoryService"
import ModalBasic from '@/components/Modal/Basic.vue'
import ClientDataService from "@/services/ClientDataService"
import SelectInput from '@/components/Form/Select-Input.vue'
import VueEasyLightbox from 'vue-easy-lightbox'
import PackageDataService from "@/services/PackageDataService"
import OperationService from "@/services/OperationService"

export default {
  name: 'Inventories',
  mixins: [helper],
  components: { ModalBasic, SelectInput, VueEasyLightbox },
  data() {
    return {
      dispachAll: 0,
      keyPackages: 0,
      isDispatching: false,
      noLimit: false,
      typeChangeSt: false,
      updateMultiplePacks: [],
      sendEmail: "",
      sendCC: '',
      buttonsHidden: false,
      activeSendReport: false,
      packageId: "",
      dateFilter: '',
      pkgCurrentStatus: { id: 2, name: "PreAlerta" },
      modalActive: false,
      confirmStatus: false,
      searchkeyword: '',
      message: '',
      postId: 0,
      page: 1,
      countPost: 0,
      packageStats: [],
      packID: 0,
      newStatus: {},
      package: new PackageModel(),
      packages: [],
      tempPackges: [],
      Roles: [],
      boxActive: null,
      keyword: "",
      filterObj: {
        dateFilter: null,
        status: null,
        filter: ""
      },
      colorSelected: '',

      inventories: [],

      customer: {},
      customers: [],
      invId: '',
      tracking: "",
      customerName: "",
      location: "",

      visible: false,
      imgs: '',  // Img Url , string or Array of string
      packIdSelected: "",
      customerId: "",
      fileBill: "",
      modalAttachBill: false,
      stateFileUpload: false,

      invDelete: 0,

    }
  },
  created() {
    this.Roles = Role
  },
  computed: {
    ...mapState([
      'userInfoData'
    ]),
  },
  beforeMount() {
    this.$Progress.start();
  },
  mounted() {
    this.retrieveCustomers();
    this.getInventories();
    // this.retrievePackages()
  },
  validations: {
    package:
    {
      status: { required },
    },
  },
  methods: {
    async changeDispathAll() {
      // Verificamos si hay elementos en la lista de inventarios
      if (this.inventories.length === 0) return;
      this.isDispatching = true;
      for (const item of this.inventories) {
        if (item.pkg01Id != null) {
          const option = this.dispachAll === true ? 1 : 0;
          await PackageDataService.statusPreAlert({ id: item.pkg01Id, status: option });
          item.prealerted = this.dispachAll;
          console.log(`Paquete ${item.pkg01Id} despachado con estado: ${option}`);
        }
      }
      this.isDispatching = false;
      this.getInventories();
    },
    checkAllDispatched() {
      if (this.inventories.length > 0) {
        this.dispachAll = this.inventories.every(item => item.prealerted);
      } else {
        this.dispachAll = false;
      }
    },
    openModalFile(packId, customerId) {
      this.modalAttachBill = true;
      this.packIdSelected = packId;
      this.customerId = customerId;
    },
    closeModalFile() {
      this.fileBill = "";
      this.stateFileUpload = false;
      this.modalAttachBill = false;
      this.customerId = "";
      this.$refs.file.value = null;
    },
    uploadFile() {
      this.fileBill = this.$refs.file.files[0];

    },
    sendFileToServer() {
      const path = '/files/upload';
      this.stateFileUpload = true;
      let formData = new FormData();
      formData.append('file', this.fileBill);
      formData.append('fileName', "pack_" + this.packIdSelected);
      formData.append('type', 'Invoice');
      formData.append('customer', this.customerId);
      OperationService.uploadFileServer(formData, path)
        .then(response => {
          console.log(response);
          PackageDataService.get(this.packIdSelected)
            .then(resp => {
              console.log(resp);
              let objPack = new PackageModel();
              objPack.unit = { code: 'lb', name: "Libras" }
              objPack.tax = resp.data.tax
              objPack.id = resp.data.package.id
              objPack.guide = resp.data.package.guide
              objPack.price = resp.data.package.price
              objPack.weight = resp.data.package.weight
              objPack.tracking = resp.data.package.tracking
              objPack.customerId = resp.data.customer[0].id
              objPack.finalized = resp.data.package.finalized
              objPack.status = { id: resp.data.package.st01Code, name: resp.data.package.statusname }
              objPack.resource = resp.data.package.url
              objPack.comments = resp.data.package.comments
              objPack.delivery = { code: resp.data.package.dvcode, name: resp.data.package.dvdesc }
              objPack.preAlerted = resp.data.package.prealerted;
              objPack.followUp = resp.data.package.followUp;
              objPack.packageId = resp.data.package.id
              objPack.url = response.data.url;
              objPack.resource = response.data.url;

              objPack.otherCost = 0;
              objPack.otherTaxes = 0;
              PackageDataService.updatePackageCost(objPack)
                .then(response => {
                  console.log(response);
                  let packInv = this.inventories.find(item => item.pkg01Id == this.packIdSelected);
                  if (packInv) {
                    packInv.image = response.data.url;
                  }
                  this.closeModalFile();
                  this.modalAttachBill = false;
                  this.stateFileUpload = false;
                })
                .catch(e => {
                  console.log(e)
                });
            })
            .catch(e => {
              console.log(e)

            });
        })
        .catch(e => {
          console.log(e);
          this.stateFileUpload = false;
          this.$vs.notify({ title: 'Información!', text: 'Error cargando el archivo.', color: 'danger', icon: 'check' })
        });
    },
    changePrealerted(packId, preAlert) {
      PackageDataService.statusPreAlert({ id: packId, status: preAlert == true ? 1 : 0 })
        .then(() => {
        })
        .catch(() => {
        });
    },
    retrieveCustomers() {
      ClientDataService.getAll()
        .then(response => {
          response.data.forEach(element => {
            this.customers.push({
              id: element.id,
              name: element.fullName,
              email: element.email,
              customerType: element.typecode
            })
          });
          this.customer = this.customers[0]
        })
        .catch(e => {
          console.log(e)
          this.$vs.notify({ title: 'Error!', text: 'Error obteniendo los clientes!', color: 'danger', icon: 'error_outline' })
        });
    },
    getInventories() {

      let obj = {
        "tracking": this.tracking,
        "customerName": this.customerName,
        "ubication": this.location
      }

      if (this.dateFilter != '' && this.dateFilter != null) {
        obj.begDa = this.$moment(this.dateFilter.start).format('YYYY/MM/DD');
        obj.endDa = this.$moment(this.dateFilter.end).format('YYYY/MM/DD');
      }
      // this.filterObj.status  = this.boxActive
      // this.filterObj.filter  = this.keyword
      // this.filterObj.letters = this.lettersSelected
      // this.filterObj.color   = this.colorSelected

      InventoryService.getInventory(obj)
        .then(response => {
          console.log(response);
          this.inventories = response.data.records;
          this.$Progress.finish()
        })
        .catch(e => {
          console.log(e)
          //   this.$Progress.finish()
          //   this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          //   this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    },
    handleAssign() {
      InventoryService.addUser({ cu01Id: this.customer.id, id: this.invId })
        .then(() => {

          this.modalActive = false

          this.$vs.notify({ title: 'Información!', text: 'El usuario fue asignado correctamente!', color: 'success', icon: 'check' })
        })
        .catch(e => {
          console.log(e)
          this.$vs.notify({ title: 'Error!', text: 'Error asignado el usuario', color: 'danger', icon: 'error_outline' })
        });
    },
    openModal(id) {
      this.invId = id
      this.modalActive = true
    },
    closeModal() {
      this.modalActive = false
    },
    showSingle(url) {
      if (this.isPdf(url)) {
        window.open(url);
      } else {
        this.imgs = url
        this.visible = true
      }
    },
    handleHide() {
      this.visible = false
    },
    onConfirmDeleteInv(invId) {
      console.log('==here 1===');
      this.invDelete = invId;
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `Confirmar`,
        text: '¿Estas seguro de eliminar el paquete de inventario?',
        accept: this.onDeleteInvPack
      })
    },
    async onDeleteInvPack() {
      InventoryService.deleteInventory(this.invDelete)
        .then(response => {
          console.log(response);
          if (response.data.success) {
            this.$vs.notify({ title: 'Información', text: 'La fila fue eliminada exitosamente!', color: 'success', icon: 'check' })
            this.inventories = this.inventories.filter(item => item.id !== this.invDelete);
            this.invDelete = 0;
          } else {
            this.$vs.notify({ title: 'Información', text: 'Error eliminado el paquete', color: 'danger', icon: 'error_outline' })
          }
        })
        .catch(e => {
          console.log(e)
          //   this.$Progress.finish()
          //   this.$vs.loading.close('.vs-con-loading__container .con-vs-loading')
          //   this.$vs.notify({title:'Error!',text:'Error obteniendo los paquetes!',color:'danger',icon:'error_outline'})
        });
    }
  }
}
</script>
